import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class ClientsPerformanceRoute extends Route {
	@service('model-manager/client-metrics')
	declare mmClientMetricsService: Service.ModelManager.ClientMetrics;
	@service('model-manager/metrics')
	declare mmMetricsService: Service.ModelManager.Metrics;

	override beforeModel() {
		void this.mmMetricsService.requestMetrics();
		void this.mmClientMetricsService.requestClientMetricsData();

		return this.mmClientMetricsService.requestClientMetrics();
	}
}
